import { useQuery } from "@tanstack/react-query";
import { AuctionCard, type AuctionCardData } from "@/components/auction-card";
import { fetchPublicSellersByIds } from "@/lib/public-sellers";
import { useTranslation } from "@/i18n";

export function AuctionGrid({
  auctions,
  emptyText,
}: {
  auctions: AuctionCardData[];
  emptyText?: string;
}) {
  const { t } = useTranslation("auctions");
  const sellerIds = auctions.map((a) => a.seller_id).filter((v): v is string => !!v);
  const sellerKey = [...new Set(sellerIds)].sort().join(",");
  const { data: sellers } = useQuery({
    queryKey: ["public-sellers", sellerKey],
    queryFn: () => fetchPublicSellersByIds(sellerIds),
    enabled: sellerIds.length > 0,
    staleTime: 60_000,
  });

  if (auctions.length === 0) {
    return (
      <div className="rounded-xl border border-dashed border-border/60 bg-card/40 p-10 text-center text-sm text-muted-foreground">
        {emptyText ?? t("noneYet", "No auctions to show yet.")}
      </div>
    );
  }
  return (
    <div className="grid gap-5 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4">
      {auctions.map((a) => {
        const s = a.seller_id ? sellers?.get(a.seller_id) : undefined;
        return (
          <AuctionCard
            key={a.id}
            auction={a}
            isVerifiedSeller={s?.is_verified_seller ?? false}
            sellerRating={s?.seller_rating ?? null}
            sellerRatingCount={s?.seller_rating_count ?? null}
          />
        );
      })}
    </div>
  );
}

